module.exports = __webpack_public_path__ + "img/img_2.9983a5c3.png";